import apiErrors from './errors'
import misc from './misc'
import asset from './asset'
import jira from './jira'
import bookmark from './bookmark'
import audit from './audit'
import bp from './bp'
import customField from './custom-field'
import history from './history'
import review from './review'
import securityNeed from './security-need'
import status from './status'
import dateRange from './date-range'
import massEdit from './mass-edit'
import date from './date'
import module from './module'
import method from './method'
import roles from './roles'
import responsibleCost from './responsible-cost'
import dashboard from './dashboard'
import rule from './rule'
import user from './user'
import reference from './reference'
import risk from './risk'
import settings from './settings'
import threat from './threat'
import vulnerability from './vulnerability'
import document from './document'
import journal from './journal'
import pdf from './pdf'
import importLocale from './import'

export default {
	apiErrors,
	misc,
	jira,
	bookmark,
	asset,
	audit,
	bp,
	customField,
	history,
	review,
	securityNeed,
	status,
	dateRange,
	massEdit,
	date,
	module,
	method,
	roles,
	responsibleCost,
	dashboard,
	rule,
	user,
	reference,
	risk,
	settings,
	threat,
	vulnerability,
	document,
	journal,
	pdf,
	import: importLocale,

	// need to sort all these as well:
	language: 'Keel',
	estonian: 'Eesti',
	english: 'Inglise',
	assets: 'Varad',
	dataAssets: 'Infovarad',
	role: 'Roll | Rollid',
	permissions: 'Õigused',
	customFields: 'Lisaväljad',
	logout: 'Logi välja',
	standardVersionUpdateAvailable: 'Standardite versiooni uuendus on saadaval',
	notComplete: 'Rakendamata',
	byModules: 'Moodulite kaupa',
	normal: 'Normaalne',
	big: 'Suur',
	veryBig: 'Väga suur',
	businessProcesses: 'Äriprotsessid',
	standardUpgrade: 'Standardiuuendus',
	measureImport: 'Meetmete import',
	overallStatus: 'Üldine seisunud',
	measure: 'Meede | Meetmed',
	active: 'Aktiivne',
	notActive: 'Mitte aktiivne',
	price: 'Hind',
	connections: 'Seotud objektid',
	send: 'Saada',
	login: 'Logi sisse',
	idCard: 'ID kaart',
	activate: 'Aktiveeri',
	licenseCode: 'Litsentsi kood',
	licenseExpires: 'Litsents aegub',
	confidentiality: 'Konfidentsiaalsus',
	availability: 'Käideldavus',
	integrity: 'Terviklus',
	dataAsset: 'Infovara',
	title: 'Pealkiri',
	responsible: 'Vastutav',
	priority: 'Prioriteet',
	subrule: 'Alamreegel',
	low: 'Madal',
	medium: 'Keskmine',
	high: 'Kõrge',
	editMeasure: 'Meetme muutmine',
	main: 'Põhi',
	standard: 'Standard',
	modules: 'Moodulid',
	relatedAssets: 'Seotud varad',
	vb: 'VS',
	b: 'S',
	n: 'N',
	code: 'Kood',
	description: 'Kirjeldus',
	chooseAsset: 'Vali vara',
	h: 'K',
	s: 'S',
	m: 'P',
	measuresFound: 'Leitud meetmete arv',
	columnsOptions: 'Kuvatavad andmed',
	measureConnectionsFound: 'Leitud meetme seoste arv',
	appliedUserRights: 'Rakendatud kasutajaõigused',
	userRights: 'Kasutajaõigused',
	editMethod: 'Meetodi muutmine',
	chooseBusinessProcess: 'Vali äriprotsess',
	chooseModule: 'Vali moodul',
	owner: 'Omanik',
	location: 'Asukoht',
	firstname: 'Eesnimi',
	lastname: 'Perenimi',
	idCode: 'Isikukood',
	password: 'Parool',
	email: 'E-mail',
	emailActivate: 'E-mailiga aktiveerimine',
	phone: 'Telefon',
	contact: 'Kontakt',
	mainInstitution: 'Peaasutus',
	adUser: 'AD kasutajanimi',
	contactResponsible: 'Kontakt/vastutav',
	association: 'Seos | Seoseid',
	allBusinessProcesses: 'Kõik äriprotsessid',
	assetAssociations: 'Vara seosed',
	methods: 'Meetmed',
	institution: 'Asutus | Asutused',
	securityMethodChangedSuccessfully: 'Turvameetod edukalt muudetud',
	relatedDataAssets: 'Seotud infovarad',
	hasPersonalData: 'Sisaldab isikuandmeid',
	methodWillNotApply: 'Meedet ei kohaldata',
	methodWillNotImplement: 'Meedet ei rakendata',
	methodNotImplemented: 'Meede on rakendamata',
	methodImplemented: 'Rakenda kõik reeglid',
	willNotApplyCommentRequired: 'Nõutud on selgitus miks antud meedet ei rakendata.',
	instance: 'Asutus',
	version: 'Versioon',
	activationEmailSent: 'Aktiveerimise e-mail on saadetud',
	standardVersion: 'Standardi versioon',
	userManual: 'Kasutusjuhend',
	downloadUsermanual: 'Lae alla kasutusjuhend',
	address: 'Aadress',
	progressTooltip: 'Meetmeid: {count}\nProtsent: {percentage}%\nStaatus: {status}',
	columns: 'Tulbad',
	connectionColumns: 'Seosed',
	businessProcess: 'Äriprotsess',
	lastReview: 'Viimane kontroll',
	confirmUserDelete: 'Palun kinnita kasutaja kustutamine',
	confirmRoleDelete: 'Palun kinnita rolli kustutamine',
	replacementResponsible: 'Vastutaja asendatakse',
	custom: 'Kohandatud',
	respObjects: 'Vastutav objektide eest',
	noResponsibilitiesToTransfer: 'ei ole ühtegi vastutust, mida saaks üle anda.',
	confirmUserReplaceResponsible: 'Kasutaja kellelt võetakse vastutus üle',
	confirmRoleReplaceResponsible: 'Roll millelt võetakse vastutus üle',
	risks: 'Riskid',
}
